import {createSlice} from '@reduxjs/toolkit';
const docExecutionSlice = createSlice({
  name: 'docExecutionSlice',
  initialState: {
    isUploadEnabled: false,
  },
  reducers: {
    setisUploadEnabled: (state, action) => {
      state.isUploadEnabled = action.payload;
    },
  },
});

export const {setisUploadEnabled} = docExecutionSlice.actions;

export default docExecutionSlice.reducer;
